import React from 'react';
import PropTypes from 'prop-types';
import { getTechnicalsSpecifications } from 'shared/helpers/transportInfo';
import { withTranslate } from 'shared/hocs/withTranslate';
import {
  SpeedIcon,
  GearboxIcon,
  CalendarIcon,
  EngineIcon,
  ChassisIcon,
} from 'shared/components/Icons';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { sliceArrayIntoChunks } from 'shared/helpers/arrays';

import s from './TransportGridDetails.css';

const renderItem = (item, className = '') => {
  const Icon = item.icon;
  return (
    <span key={item.slug} className={cx(s.item, { [className]: !!className })}>
      {Icon && <Icon />}
      {item.title}
    </span>
  );
};

class TransportGridDetails extends React.Component {
  static propTypes = {
    advert: PropTypes.shape().isRequired,
    itemClassName: PropTypes.string.isRequired,
    chunksCount: PropTypes.number,
    direction: PropTypes.string,
    t: PropTypes.func.isRequired,
  };
  static defaultProps = {
    direction: 'row',
    itemClassName: '',
    chunksCount: 2,
  };

  render() {
    const { advert, t, itemClassName, chunksCount, direction } = this.props;

    const getItems = ['year', 'engine', 'drive', 'mileage', 'gearbox', 'location'];

    const preparedItems = getTechnicalsSpecifications(advert, getItems, t);
    const chunks = sliceArrayIntoChunks(preparedItems, preparedItems.length / chunksCount);
    const rootClass = direction === 'row' ? s.rootRow : s.rootColumn;

    const styleObject = { width: `${100 / chunksCount}%` };

    return (
      <div className={rootClass}>
        {chunks.map((chunk, idx) => (
          // eslint-disable-next-line react/no-array-index-key
          <div className={s.chunk} key={`chunnk-${idx}`} style={styleObject}>
            {chunk.map(item => renderItem(item, itemClassName, t))}
          </div>
        ))}
      </div>
    );
  }
}

export default withStyles(s)(withTranslate(TransportGridDetails));



// WEBPACK FOOTER //
// ./src/shared/components/TransportGridDetails/TransportGridDetails.js